export const queryKeys = {
  works: ['works'] as const,
  work: (workId: string) => ['works', workId] as const,
  summary: (workId: string) => ['works', workId, 'summary'] as const,
  timeline: (workId: string) => ['works', workId, 'timeline'] as const,
  graph: (workId: string) => ['works', workId, 'graph'] as const,
  provisions: (versionId: string, offset = 0, limit = 100) =>
    ['provisions', versionId, offset, limit] as const,
  diff: (from: string, to: string, includeUnchanged = false) =>
    ['diff', from, to, includeUnchanged] as const,
  blame: (workId: string, versionId: string) => ['blame', workId, versionId] as const,
  evidence: (changeId: string) => ['evidence', changeId] as const,
  classifications: (workId: string, changeClass?: string, offset = 0, limit = 50) =>
    ['classifications', workId, changeClass, offset, limit] as const,
  search: (query: string, mode = 'latest', workId?: string, k = 10) =>
    ['search', query, mode, workId, k] as const,
  stats: ['stats'] as const,
  metrics: ['metrics'] as const,
  coverage: (workId?: string) => ['coverage', workId] as const,
};
